import { OLDEST_TIME } from '@customer/config/time';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { AssetModel, PositionModel } from '@customer/store/apis/assetsApi';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { MapViewProps } from '../map-view/MapView';
import usePositionsOnMap from './usePositionsOnMap';

export const useAssetPositionsOnMap = (asset: AssetModel | undefined): MapViewProps => {
  const { parseFromIso } = useLocaleFormatter();

  const positionModels = useMemo<Array<PositionModel | null | undefined>>(() => {
    if (typeof asset === 'undefined') {
      return [];
    }

    const positionModels: Array<PositionModel | null | undefined> = [asset.posG];

    const minTime = DateTime.fromISO(OLDEST_TIME);
    const lastReportTime = asset.posG ? parseFromIso(asset.posG.ts) : minTime;
    const seenTime = asset.posS ? parseFromIso(asset.posS.ts) : minTime;
    const seenIsMoreRecent = seenTime > lastReportTime;

    if (seenIsMoreRecent) {
      positionModels.push(asset.posS);
    }

    return positionModels;
  }, [asset, parseFromIso]);

  const mapProps = usePositionsOnMap(positionModels);

  return mapProps;
};

export default useAssetPositionsOnMap;
